<div class="login-page d-flex">
  <div class="col-sm-5">
    <form class="login-content">
      <img
        [addAaTags]="'IN SOS logo'"
        src="/img/logo.png"
        class="login-logo"
        alt="Indiana Secretary of State Logo"
      />
      <div class="login-inner">
        <div class="display--flex flex--justify-center mb-2">
          <h1 class="login__primary-title">
            Welcome to Indiana SOS Search Portal
          </h1>
          <div class="login__primary-sub_title">{{ subTitle }}</div>
        </div>
        <div
          *ngIf="errorText"
          id="login-form-error"
          class="error-text"
          role="alert"
          aria-atomic="true"
        >
          <img
            src="icons/linear/error-icon.svg"
            alt=""
            aria-hidden="true"
          />
          <p>{{ errorText }}</p>
        </div>
        <div class="row form-container">
          @if (showVefifyOtp) {
          <app-input
            [id]="'enter-otp'"
            [required]="true"
            [showLabel]="true"
            name="otp"
            [control]="otp"
            label="Enter OTP"
            className="bg-light-blue"
            class="col-12 pb-15"
            placeholder="Enter one time password"
            aria-label="Enter One Time Password"
            [ariaDescribedby]="errorText ? 'login-form-error' : ''"
            [ariaInvalid]="!!errorText"
          ></app-input>
          <app-button
            label="{{ viewConfig.loading ? 'Logging In...' : 'Verify OTP' }}"
            type="primary"
            class="col-12 mt-2 w-100"
            (click)="verifyOtp()"
            (keydown.enter)="verifyOtp()"
            (keydown.space)="verifyOtp()"
            aria-label="Verify OTP Button"
          ></app-button>
          <div class="reenter-mobile pt-2 d-flex" *ngIf="phone.value">
            <span class=""
              >Not receiving text message for OTP on {{ phone.value }}?
              <a
                class=""
                (click)="showMobileNumberScreen()"
                (keydown.enter)="showMobileNumberScreen()"
                (keydown.space)="showMobileNumberScreen()"
                role="button"
                aria-label="Change Phone Number"
                >Change Phone Number.</a
              ></span
            >
          </div>
          }@else if (showEnableMFA) {
          <app-input
            [maxlength]="14"
            [id]="'enter-phone'"
            [className]="phoneInputClass"
            [required]="true"
            toolTip="In order to enter your phone number for two factor authentication please enter your phone number"
            [showLabel]="true"
            label="Enter phone number"
            placeholder="Please enter your phone number"
            [control]="phone"
            (input)="formatPhoneNumber($event)"
            [ariaDescribedby]="errorText ? 'login-form-error' : ''"
            [ariaInvalid]="!!errorText"
          ></app-input>
          <app-button
            label="{{ viewConfig.loading ? 'Sending OTP...' : 'Get OTP' }}"
            type="primary"
            class="col-12 mt-2 w-100"
            (click)="initiateMFA()"
            (keydown.enter)="initiateMFA()"
            (keydown.space)="initiateMFA()"
          ></app-button>
          }@else {
          <app-input
            id="enter-username"
            [showLabel]="true"
            label="Username/Email"
            [required]="true"
            className="bg-light-blue"
            class="col-12 pb-15"
            placeholder="Enter Username/Email"
            [control]="emailControl"
            [ariaDescribedby]="errorText ? 'login-form-error' : ''"
            [ariaInvalid]="!!errorText"
          ></app-input>
          <label for="enter-password"
            >Password<span class="required-span">*</span></label
          >
          <div class="input-group">
            <input
              [type]="passwordInputType"
              class="form-control input-icon-parent"
              [formControl]="passwordControl"
              [attr.aria-label]="'Password, edit, required. '"
              [attr.aria-describedby]="errorText ? 'login-form-error' : null"
              [attr.aria-invalid]="errorText ? 'true' : null"
              id="enter-password"
              placeholder="Enter Password"
            />
            <div class="input-group-append">
              <button
                type="button"
                (keydown.enter)="showPasswordValue = !showPasswordValue"
                (keydown.space)="showPasswordValue = !showPasswordValue"
                class="input-icon input-group-text password-toggle-btn"
                (click)="showPasswordValue = !showPasswordValue"
                [attr.aria-label]="
                  showPasswordValue ? 'Hide password' : 'Show password'
                "
                [attr.aria-pressed]="showPasswordValue"
                aria-controls="enter-password"
              >
                <img [src]="passwordIconUrl" alt="" aria-hidden="true" />
              </button>
            </div>
          </div>
          <app-button
            label="{{ viewConfig.loading ? 'Logging In...' : 'Login' }}"
            type="primary"
            class="col-12 mt-2 w-100"
            (click)="onSubmit()"
            (keydown.enter)="onSubmit()"
            (keydown.space)="onSubmit()"
          ></app-button>
          <a
            class="pt-2"
            (click)="setForgetPassword()"
            (keydown.enter)="setForgetPassword()"
            (keydown.space)="setForgetPassword()"
            routerLink="/forgot-password"
            >Forgot Password?</a
          >
          }
        </div>
      </div>
    </form>
  </div>
  <div class="col-sm-7 side-image">
    <div class="background-image">
      <div class="login-header d-flex">
        <p>
          <a
            href="https://www.in.gov/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/in-logo.svg" [addAaTags]="'Indiana Logo'" />
          </a>
          <span class="mx-3"
            >An official application of the Indiana State Government</span
          >
        </p>
      </div>
    </div>
  </div>
</div>
